// Copyright (c) Cosmo Tech.
// Licensed under the MIT license.

export const SCENARIO_RUN_ACTIONS = {
  ADD_OR_UPDATE: 'ADD_OR_UPDATE',
  FETCH: 'FETCH',
  SET_RUN_STATUS: 'SET_RUN_STATUS',
  STOP_SCENARIO_RUN: 'STOP_SCENARIO_RUN',
};
